import Badge from './Badge';

// export types
export type { BadgeProps } from './Badge';

// export components
export { Badge };
export default Badge;
